module.exports = __webpack_public_path__ + "media/images/rearrange-670cf44c752645535b3409030a058096.svg";